import { Expose, Type } from "class-transformer";
import CompanyRes from "../company/CompanyRes";
import { PlanType } from "types/enum/PlanType";
import { BusinessType } from "types/enum/BusinessType";

export default class CompanyGroupRes {
  @Expose() readonly companyGroupId!: number;
  @Expose() readonly name!: string;
  @Expose() readonly kana!: string;
  @Expose() readonly plan!: PlanType;
  @Expose() readonly businessType!: BusinessType;
  @Expose() readonly isMonthlyPaid!: boolean;
  @Expose() readonly invoiceUrl!: string;
  @Type(() => Date)
  @Expose()
  readonly recessedAt!: Date | null;
  @Type(() => CompanyRes)
  @Expose()
  readonly companies!: CompanyRes[];
}
